import React from "react";

const Spinner = () => {
  return (
    <div className="section">
      <div className="spinner-border">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
